import { generateSvgLayer } from '../helpers/svgLayerConverter';
import { getCachedCanvas, setCachedCanvas } from '../services/CanvasCache';

const MAP_WIDTH = 2000;
const MAP_HEIGHT = 4000;

export default class Floor {
  constructor(id, name, numberRepresentation, mapImage) {
    this.id = id;
    this.name = name;
    this.mapImage = mapImage;
    this.numberRepresentation = numberRepresentation;
    this.canvasImage = null;
  }

  async generateCanvasImage() {
    if (this.canvasImage) {
      return this.canvasImage;
    }

    const cacheKey = `${this.id}:${MAP_WIDTH}x${MAP_HEIGHT}:${hashString(
      this.mapImage || ''
    )}`;

    const cachedCanvas = await getCachedCanvas(cacheKey, MAP_WIDTH, MAP_HEIGHT);

    if (cachedCanvas) {
      this.canvasImage = cachedCanvas;
      return this.canvasImage;
    }

    this.canvasImage = await generateSvgLayer(
      // eslint-disable-line
      this.mapImage,
      MAP_WIDTH,
      MAP_HEIGHT
    );

    setCachedCanvas(cacheKey, this.canvasImage);

    return this.canvasImage;
  }
}

function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 1000000007;
  }
  return hash.toString(36);
}
